import MolhamModalOffcanvas from "components/MolhamModalOffCanvas";
import useMobile from "customHooks/useMobile";
import useTranslation from "next-translate/useTranslation";
import dynamic from "next/dynamic";
import { useState } from "react";
import shareAnimation from "../../public/lottie/shareAnimation.json";
import CopyLinkInput from "./CopyLinkInput";
import NativeMobileShareBtn from "./NativeMobileShareBtn";
import ShareButtonsBar from "./ShareButtonsBar";
const Lottie = dynamic(() => import("lottie-react"));

type Props = {
  showShareModal: boolean;
  handleCloseShareModal: () => void;
  shareURL: string;
  title: string;
};
const ShareModal = ({
  showShareModal,
  handleCloseShareModal,
  shareURL,
  title,
}: Props) => {
  const [copied, setCopied] = useState(false);
  const fixedShareURL =
    shareURL && shareURL?.startsWith("http") ? shareURL : `https://${shareURL}`;

  const onModalHide = () => {
    handleCloseShareModal();
    setCopied(false);
  };

  const { t } = useTranslation("common");
  const matches = useMobile("lg");

  return (
    <MolhamModalOffcanvas
      show={showShareModal}
      onHide={onModalHide}
      body={{ className: "p-0" }}
    >
      <div className="pb-4 pb-md-3">
        <Lottie
          className="w-50 m-auto"
          animationData={shareAnimation}
          loop={true}
          style={{ maxWidth: matches ? 300 : 400 }}
        />
        <p className="text-center mb-2 px-2">{t(`share_prompt`)}</p>
        {!matches && (
          <>
            <CopyLinkInput
              shareUrl={fixedShareURL}
              copied={copied}
              setCopied={setCopied}
            />
            <div className="border-bottom mb-3 pt-2"></div>
            <p className="text-center">{t(`share_via_social_prompt`)}</p>

            <ShareButtonsBar title={title} shareUrl={fixedShareURL} size={25} />
          </>
        )}
        {matches && (
          <NativeMobileShareBtn
            title={title}
            url={fixedShareURL}
            close={handleCloseShareModal}
          />
        )}
      </div>
    </MolhamModalOffcanvas>
  );
};

export default ShareModal;
